// Story 10.1 — Pure helper para derivar breadcrumbs de un pathname. Aislado
// del componente para que sea testeable sin un router montado.

export interface Crumb {
  label: string;
  to?: string;
}

const PATH_LABELS: Record<string, string> = {
  '/': 'Dashboard',
  editor: 'Editor',
  conversations: 'Conversaciones',
  analytics: 'Analytics',
  settings: 'Settings',
  bots: 'Bots',
  organizations: 'Organizaciones',
  account: 'Cuenta',
  admin: 'Admin',
  users: 'Usuarios',
  audit: 'Auditoría',
};

/**
 * Convierte un pathname (`/bots/42/editor`) en una lista de crumbs. Si se
 * pasa `botName`, reemplaza el id numérico por el nombre legible.
 */
export function buildCrumbs(pathname: string, botName?: string): Crumb[] {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length === 0) return [{ label: 'Dashboard', to: '/' }];

  const crumbs: Crumb[] = [{ label: 'Dashboard', to: '/' }];
  let acc = '';
  for (let i = 0; i < parts.length; i++) {
    const segment = parts[i];
    acc += `/${segment}`;
    const previous = parts[i - 1];
    if (previous === 'bots' && /^\d+$/.test(segment)) {
      crumbs.push({ label: botName ?? `Bot #${segment}`, to: acc });
    } else if (previous === 'organizations' && /^\d+$/.test(segment)) {
      crumbs.push({ label: `Organización #${segment}`, to: acc });
    } else if (segment === 'bots') {
    } else {
      crumbs.push({ label: PATH_LABELS[segment] ?? segment, to: acc });
    }
  }
  return crumbs;
}
